import http from "api/httpClient";

export type CellColor = "RED" | "GREEN";

export type Cell = {
    value: number | null;
    color: CellColor;
    display: string;
};

export type RuleKey =
    | "MRR"
    | "CM"
    | "OVERDUE_60D"
    | "UNBILLED_EXCL_STOCK"
    | "FRAGMENTATION";

export type CustomerHealthRow = {
    customer_code: string;
    customer_name: string;
    mrr: Cell;
    cm_pct: Cell;
    overdue_gt_60d: Cell;
    unbilled_excl_stock: Cell;
    fragmentation: Cell;
    distinct_branches: number;
    red_count: number;
};

export type SortField =
    | "customer_name"
    | "customer_code"
    | "mrr"
    | "cm_pct"
    | "overdue_gt_60d"
    | "unbilled_excl_stock"
    | "long_tail_share"
    | "distinct_branches"
    | "red_count";

export type SortDir = "asc" | "desc";

export type CustomerHealthRequest = {
    search?: string;
    red_rules?: RuleKey[];
    sort?: { by: SortField; dir: SortDir };
    page?: number;
    page_size?: number;
};

export type CustomerHealthResponse = {
    total: number;
    items: CustomerHealthRow[];
};

export async function fetchCustomerHealth(
    payload: CustomerHealthRequest
): Promise<CustomerHealthResponse> {
    return http.post("/api/v1/dashboard/customer-health/fetch-data", payload);
}
